import { DeviceSubscriptionDetails } from "@api-commons/stats/UserActionTypes.js";
import { SimpleEventHandler } from "@ciaopeople/cp-shatsu/EventHandler";
import { isFunction, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";
import { BookmarkQueryWithSaved } from "./types/BookmarkingDataTypes.js";
import { isTopicQueryObjWithFollow, isTopicQueryObjWithSubscribe, TopicQueryObjWithFollow, TopicQueryObjWithSubscribe } from "./types/NotificationDataTypes.js";

export const RESTAPIEventNames = {

    TOPIC_FOLLOW_STATUS_CHANGE: "topicFollowStatusChange",
    NEWSLETTER_SUBSCRIPTION_STATUS_CHANGE: "newsletterSubscriptionStatusChange",
    ARTICLE_SAVE_STATUS_CHANGE: "articleSaveStatusChange",
    DEVICE_SUBSCRIPTION_CHANGE: "deviceSubscriptionChange",


    USER_TOPIC_FOLLOW_ACTION: "userTopicFollowAction",
    USER_ARTICLE_SAVE_ACTION: "userArticleSaveAction",
    USER_NEWSLETTER_SUBSCRIPTION_ACTION: "userNewsletterSubscriptionAction",
};



export interface RESTAPIEvents {
    onTopicFollowStatusChange(fun: (query: TopicQueryObjWithFollow) => any): void
    onArticleSaveStatusChange(fun: (t: BookmarkQueryWithSaved) => any): void
    onDeviceSubscriptionChange(fun: (t: DeviceSubscriptionDetails) => any): void
    onNewsletterSubscriptionStatusChange(fun: (query: TopicQueryObjWithSubscribe) => any): void 
    
    onUserTopicFollowAction(fun: (query: TopicQueryObjWithFollow) => any): void
    onUserArticleSaveAction(fun: (query: BookmarkQueryWithSaved) => any): void
    onUserNewsletterSubscribeAction(fun: (query: TopicQueryObjWithSubscribe) => any): void;
}

export function isRESTAPIEvents(obj: any): obj is RESTAPIEvents {
    return isObject(obj) && 
        isFunction(obj['onTopicFollowStatusChange']) && 
            isFunction(obj['onArticleSaveStatusChange']) && 
                isFunction(obj['onDeviceSubscriptionChange']) &&
                    isFunction(obj['onNewsletterSubscriptionStatusChange']);
}



export abstract class RESTAPIEventsBaseImpl  extends SimpleEventHandler implements RESTAPIEvents {
    
    public onTopicFollowStatusChange(fun: (query: TopicQueryObjWithFollow) => any): void {
        this.on(RESTAPIEventNames.TOPIC_FOLLOW_STATUS_CHANGE, (evt, data) => {
            if(isTopicQueryObjWithFollow(data)) fun(data);
        });
    }

    public onArticleSaveStatusChange(fun: (t: BookmarkQueryWithSaved) => any): void {
        this.on(RESTAPIEventNames.ARTICLE_SAVE_STATUS_CHANGE, (evt, data) => {
            fun(data);
        });
    }

    public onDeviceSubscriptionChange(fun: (t: DeviceSubscriptionDetails) => any): void {
        this.on(RESTAPIEventNames.DEVICE_SUBSCRIPTION_CHANGE, (evt, data) => {
            fun(data);
        });
    }

    public onUserTopicFollowAction(fun: (query: TopicQueryObjWithFollow) => any): void {
        this.on(RESTAPIEventNames.USER_TOPIC_FOLLOW_ACTION, (evt, data) => {
            if(isTopicQueryObjWithFollow(data)) fun(data);
        });
    }

    public onUserArticleSaveAction(fun: (t: BookmarkQueryWithSaved) => any): void {
        this.on(RESTAPIEventNames.USER_ARTICLE_SAVE_ACTION, (evt, data) => {
            fun(data);
        });
    }

    public onNewsletterSubscriptionStatusChange(fun: (query: TopicQueryObjWithSubscribe) => any): void {
        this.on(RESTAPIEventNames.NEWSLETTER_SUBSCRIPTION_STATUS_CHANGE, (evt,data) => {
            if(isTopicQueryObjWithSubscribe(data)) fun(data);
        })
    }

    public onUserNewsletterSubscribeAction(fun: (query: TopicQueryObjWithSubscribe) => any): void {
        this.on(RESTAPIEventNames.USER_NEWSLETTER_SUBSCRIPTION_ACTION, (evt, data) => {
            if(isTopicQueryObjWithSubscribe(data)) fun(data);
        })
    }
    


    protected triggerNewsletterSubscriptionStatusChange(t: TopicQueryObjWithSubscribe): void {
        this.trigger(RESTAPIEventNames.NEWSLETTER_SUBSCRIPTION_STATUS_CHANGE,t);
    }

    protected triggerTopicFollowStatusChange(t: TopicQueryObjWithFollow): void {
        this.trigger(RESTAPIEventNames.TOPIC_FOLLOW_STATUS_CHANGE, t);
    }

    protected triggerArticleSaveStatusChange(t: BookmarkQueryWithSaved): void {
        this.trigger(RESTAPIEventNames.ARTICLE_SAVE_STATUS_CHANGE, t);
    }

    protected triggerDeviceSubscriptionChange(t: DeviceSubscriptionDetails): void {
        this.trigger(RESTAPIEventNames.DEVICE_SUBSCRIPTION_CHANGE, t);
    }

    protected triggerUserTopicFollowAction(t: TopicQueryObjWithFollow): void {
        this.trigger(RESTAPIEventNames.USER_TOPIC_FOLLOW_ACTION, t);
    }

    protected triggerUserArticleSaveAction(t: BookmarkQueryWithSaved): void {
        this.trigger(RESTAPIEventNames.USER_ARTICLE_SAVE_ACTION, t);
    }

    protected triggerUserNewsletterSubscribeAction(t: TopicQueryObjWithSubscribe): void {
        this.trigger(RESTAPIEventNames.USER_NEWSLETTER_SUBSCRIPTION_ACTION, t);
    }
    
    
}